import React, { cloneElement, useEffect, useRef, useState } from 'react';
import Modal from './Modal';

import BackImage from './../../assets/images/sample_images/back.png';
import LeftImage from './../../assets/images/sample_images/left.png';
import RightImage from './../../assets/images/sample_images/right.png';
import FrontImage from './../../assets/images/sample_images/front.png';
import BackGlass from './../../assets/images/sample_images/back-glass.png';
import Glass from './../../assets/images/sample_images/glass.png';
import VehicleCardBack from './../../assets/images/sample_images/back-car-cart.png';
import Kilometr from './../../assets/images/sample_images/kilometer.png';
import Plate from './../../assets/images/sample_images/plate-top.png';
import Trunk from './../../assets/images/sample_images/trunk.png';
import Tire from './../../assets/images/sample_images/tire.png';
import ThirdImage from './../../assets/images/sample_images/third-image.jpg';
import VehicleCard from './../../assets/images/sample_images/car-cart.png';
import BackLicenseImage from './../../assets/images/sample_images/back-license.png';
import GreenCart from './../../assets/images/sample_images/green-cart.png';
import ChassisNumber from './../../assets/images/sample_images/chassis.png';
import Dashboard from './../../assets/images/sample_images/dashboard.png';
import Engine from './../../assets/images/sample_images/engine.png';
import LicenseImage from './../../assets/images/sample_images/license.png';
import PlateChassis from './../../assets/images/sample_images/plate.png';
import UnderTrunk from './../../assets/images/sample_images/under-trunk.png';
import Roof from './../../assets/images/sample_images/roof.png';

import { useTranslation } from 'react-i18next';
import ImageZoom from './ImageZoom';
import { url } from '../../utils/variables';
import { useSelector } from 'react-redux';
import { toast } from '../../utils/functions';
import FrontCar from '../../assets/images/front50.png';
import BackCar from '../../assets/images/back50.png';
import RightSideCar from '../../assets/images/right-side50.png';
import LeftSideCar from '../../assets/images/left-side50.png';

export default function ImagePickerModal({renderBtn, disableGallery, disableCamera, upload ,label = '' , imageUid}) {

    const videoRef = useRef(null);
    const [notif,setNotif] = useState(true);
    const { user } = useSelector(store => store);
    const [camera, setCamera] = useState(false);

    const [open, setOpen] = useState(false);
    const [content, setContent] = useState('picker');
    const { t } = useTranslation();
    function getImage(dataUrl) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = dataUrl;
            image.onload = () => {
                resolve(image);
            };
            image.onerror = (el, err) => {
                reject(err.error);
            };
        });
    }
    const openCamera = async () => {
        try {
            navigator.mediaDevices.getUserMedia({ video: {facingMode:"environment"} })
            .then((stream)=>{
                setCamera(true)
                setTimeout(()=>setNotif(false),2000)
                setTimeout(()=>videoRef.current.srcObject = stream)
            })
            .catch(()=>{
                toast('لطفا برای دسترسی به دوربین تنظیمات خود را مجددا بررسی کنید','error');
            })
        } catch (error) {
            toast('دسترسی به دوربین خود را فعال کنید','error');
            console.error('Error accessing camera:', error);
        }
      };
      async function takePicture() {
        setContent('loader');
        const image = videoRef.current;
        
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                upload(blob, () => {
                    setCamera(false);
                    setOpen(false);
                    setTimeout(() => setContent('picker'), 500);
                });
            },'image/jpeg', 0.7);
        }
      }
    async function submitImage(e) {
        const [file] = e.target?.files || [];
        setContent('loader');
        if (file) {
            const url = window.URL.createObjectURL(file);
            const image = await getImage(url);
            const oldWidth = image.naturalWidth;
            const oldHeight = image.naturalHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                upload(blob, () => {
                    setOpen(false);
                    setTimeout(() => setContent('picker'), 500);
                });
            },'image/jpeg', 0.7);
        }
    }
    ///
    const sampleImages = [
            {label : 'license_image' , src: LicenseImage , title: t('License')},
            {label : 'back_license_image' , src: BackLicenseImage, title: t('License back')},
            {label : 'front_image' , src: FrontImage, title: t('Front vehicle')},
            {label : 'back_image' , src: BackImage, title: t('Back vehicle')},
            {label : 'left_image' , src: LeftImage, title: t('Left side vehicle')},
            {label : 'right_image' , src: RightImage, title: t('Right side vehicle')},
            {label : 'vehicle_card_image' , src: VehicleCard, title: t('Vehicle card')},
            {label : 'vehicle_card_back_image' , src: VehicleCardBack, title: t('Vehicle card back')},
            {label : 'third_image' , src: ThirdImage, title: t('Insurance')},
            {label : 'chassis_number' , src: ChassisNumber, title: t('Engraved chassis number')},
            {label : 'expert_plate' , src: Plate, title: t('Plate')},
            {label : 'green-card' , src: GreenCart, title: t('Green card')},
            {label : 'front_glass' , src: Glass, title: t('Front glass')},
            {label : 'back_glass' , src: BackGlass, title: t('Back glass')},
            {label : 'dashboard' , src: Dashboard, title: t('Dashboard')},
            {label : 'motor' , src: Engine, title: t('Motor image')},
            {label : 'kilometer' , src: Kilometr, title:  t('Kilometr image')},
            {label : 'car-ceiling' , src: Roof, title: t('Car ceiling')},
            {label : 'tire' , src: Tire, title: t('Tire')},
            {label : 'trunk' , src: Trunk, title: t('Trunk')},
            {label : 'under_trunk' , src: UnderTrunk, title: t('Under trunk')},
            {label : 'plate_chassis' , src: PlateChassis, title: t('Plate chassis')},
    ]
    const carSides = [ 
        {label :'front_image', image : FrontCar} , 
        {label : 'back_image', image : BackCar} , 
        {label : 'left_image', image : LeftSideCar} , 
        {label : 'right_image', image : RightSideCar}
    ]
    const [showImage , setShowImage] = useState(null);
    return (
        <>
            <>
                {
                    cloneElement(renderBtn, {
                        onClick: () => setOpen(true)
                    })
                }
            </>
            
            <Modal visible={open}>
                {
                    content === 'picker' &&
                    <div className='modal-content d-flex flex-column align-items-center rtl'>
                        { (label && imageUid) &&
                            <div className='d-flex flex-column justify-center sample-image m10' style={{ minWidth : '300px'}}>
                               
                                {
                                    <>
                                                                                    
                                            {sampleImages.map(itm => itm.label === label &&
                                                <div className='d-flex flex-column' key={label}>
                                                    <h5 className='p5 mb15 border-bottom text-center'> {t('Sample image')} {itm.title} </h5>
                                                    <img style={{ width: '80%', margin: 'auto' }} src={itm.src} alt="sample" />
                                                </div>
                                            )}
                                                                       
                                        <div className='d-flex align-items-center mt10 p10 space-between uploaded-image' onClick={() => setShowImage(imageUid.uid)}>
                                                <p className='p5 text-center'><i className='fas fa-check p5 m5'/> عکس بارگذاری شده </p>
                                                <img src={`${url}/files?uid=${imageUid?.uid}&width=80&height=80`} alt="img"/>
                                            </div>                                               
                                       
                                    </>
                                }
                                
                            </div>
                }
                        
                            {
                                (label && !imageUid)
                                &&
                            <div className='d-flex flex-column sample-image m20'>
                                
                                    {sampleImages.map(itm=> itm.label === label && 
                                    <>
                                    
                                    <h5 className='p5 mb15 border-bottom text-center' key={label}> {t('Sample image')} {itm.title} </h5>
                                    <img style={{width: '90%',margin: 'auto'}} src={itm.src} alt="sample"/>
                                    
                                    </>
                                    )}
                            </div>
                            }
                        <>
                        <div className='d-flex justify-center m10' style={{width: '250px',gap:'5px'}}>
                          {
                            !disableGallery &&
                            <label className='flex1' style={{backgroundColor: '#0dd6a9',borderRadius: '5px',color:'white'}}>
                                <div className='text-center p10'><i className="fas fa-image p5" style={{fontSize: '18px'}}></i> </div>
                                <input type='file' accept='image/*' style={{display: 'none'}} onChange={submitImage}/>
                            </label>
                        }
                        {
                            !disableCamera && user.id === 89957 &&
                                <label className='flex1' style={{backgroundColor : '#1dceff',borderRadius: '5px',color:'white'}} onClick={openCamera}>
                                    <div className='p10 text-center'><i className="fas fa-camera p5" style={{fontSize: '18px'}}></i></div>
                                    {/* <input type='file' accept='image/*' capture='environment' style={{display: 'none'}} onChange={submitImage}/> */}
                                </label>
                        }
                        {
                            !disableCamera && user.id !== 89957 &&
                                <label className='flex1' style={{backgroundColor : '#1dceff',borderRadius: '5px',color:'white'}}>
                                    <div className='p10 text-center'><i className="fas fa-camera p5" style={{fontSize: '18px'}}></i></div>
                                    <input type='file' accept='image/*' capture='environment' style={{display: 'none'}} onChange={submitImage}/>
                                </label>
                            
                        }
                        <label className='flex1'>
                            <div className='p10 text-center' style={{backgroundColor: '#ff3b74',borderRadius: '5px',color:'white'}} onClick={() => setOpen(false)}>
                                <i className='fas fa-times p5' style={{fontSize: '18px'}}/>
                            </div> 
                        </label>
                        </div>
                        </>
                    
                     {/* {
                            !disableGallery &&
                            <label>
                                <div className='modalBtn'>آپلود از گالری</div>
                                <input type='file' accept='image/*' style={{display: 'none'}} onChange={submitImage}/>
                            </label>
                        }
                        {
                            !disableCamera &&
                            <label>
                                <div className='modalBtn'>آپلود از دوربین گوشی</div>
                                <input type='file' accept='image/*' capture='environment' style={{display: 'none'}}
                                       onChange={submitImage}/>
                            </label>
                        }
                        <div className='modalBtn' style={{borderBottom: 0}} onClick={() => setOpen(false)}>انصراف</div>  */}
                    </div>
                }
                {
                    content === 'loader' &&
                    <div className='loader-modal'>
                        <p>{t('Uploading image')}</p>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>

                }
            </Modal>
            <Modal visible={showImage}>
                <div className='image-modal'>
                    <i className='fas fa-times'
                       onClick={() => setShowImage(null)}
                    />
                    <ImageZoom imgUid={showImage}/>
                </div>
            </Modal>
            {user.id === 89957 && 
            <>
            <Modal visible={camera}>

            <div className='screen-camera'>
                <video ref={videoRef} autoPlay playsInline muted style={{ height: '90%'}}></video>
                {label && carSides.map((item)=> item.label === label &&
                <>
                    <div className={`tuturial-notif ${!notif && 'fade'}`}> 
                    <i className='fas fa-times' onClick={()=> setNotif(false)}/>.تلاش کنید خودرو خود را در کادر  زیر قرار دهید 
                    </div>
                    <img className='upper-image' src={item.image} />                  
                </>
                )}
                {sampleImages.map(itm => itm.label === label &&
                        <div key={label}>
                            <h5 className=' border-bottom image-title'> {itm.title} </h5>
                            <img className='sample-img' src={itm.src} alt="sample" />
                        </div>
                    )}

                <div className='d-flex justify-center align-items-center navigate-btns'>
                    <button className='capture-btn' onClick={takePicture}/>
                    <i className='fas fa-times mb25 mr30 close-btn' onClick={()=>setCamera(false)} />
                </div>
            </div>
            </Modal>
            </>
            }
        </>
    );
}
